<script setup>
import { onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import TitleCard from '@/components/TitleCard.vue'
import IconChevron from '@/components/icons/IconChevron.vue'

const { locale } = useI18n()

onBeforeMount(() => {
  locale.value = 'en'
})

const router = useRouter()

const nav = (es = false) => {
  if (es) {
    locale.value = 'es'
  }
  router.push({ name: 'home' })
}
</script>

<template>
  <div class="grid grid-cols-2 p-8">
    <div>
      <img src="/images/cover.png" class="w-full h-[1000px] object-contain" draggable="false">
    </div>
    <div class="relative flex items-end pb-[8px]">
      <TitleCard class="absolute bottom-1/2 translate-y-1/2" />
      <div class="w-full flex gap-x-[50px]">
        <button class="cta-button" @click="nav(false)">
          <h2>Tap to Explore</h2>
          <IconChevron />
        </button>
        <button class="cta-button" @click="nav(true)">
          <h2>Toca para Explorar</h2>
          <IconChevron />
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="postcss">
.cta-button {
  @apply flex items-center gap-x-8 bg-olive text-cream fill-cream font-medium text-lg;
  padding: 25px;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 25%);
}

</style>